import React, { useState, useEffect } from 'react';
import { RemoveRedEye, Check, Clear } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';
import { toaster } from 'evergreen-ui';
import Quotations from '../api/quotations';
import Categories from '../api/categories';
import Divider from '../components/ui/Divider';
import Modal from '../components/ui/Modal';
import SelectFilter from '../components/ui/SelectFilter';
import { toInteger } from '../utilities';
/* eslint max-len: ["error", { "code": 250 }] */

const UserQuotations = () => {
  const [showAddAdditionalInfo, setShowAddAdditionalInfo] = useState({
    showModal: false,
    id: true,
    quotation_name: true,
    machine: true,
    materials: false,
    category: true,
    cost_per_piece: false,
    cost_electricity: false,
    cost_operator: false,
    cost_total_per_piece: true,
    price_per_design: true,
    utility: true,
    pieces_to_sell: false,
    show_pdf: false,
  });
  const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
  const [showFilterOptions, setShowFilterOptions] = useState(false);
  const [showOrderOptions, setShowOrderOptions] = useState(false);
  const [isLoading, setIsLoading] = useState({ categories: false, quotations: false });
  const [allQuotations, setAllQuotations] = useState([]);
  const [mockQuotations, setMockQuotations] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState({});
  const [newCategoryAdded, setNewCategoryAdded] = useState({ value: '', count: 1, isValidCategoryName: null });
  const userId = localStorage.getItem('id');

  const handleCreateCategory = async () => {
    if (!newCategoryAdded.value || !newCategoryAdded.isValidCategoryName) {
      return toaster.danger('Datos invalidos', {
        id: 'forbidden-action',
        duration: 1.5,
      });
    }
    setIsLoading((prevState) => ({ ...prevState, categories: true }));
    setSelectedCategory({});
    const newCategory = await Categories.createCategoryByUser({ name: newCategoryAdded.value }, userId);
    setIsLoading((prevState) => ({ ...prevState, categories: false }));
    if (newCategory.id) {
      setNewCategoryAdded((prevState) => ({ value: '', count: prevState.count + 1 }));
    }
    return undefined;
  };

  const handleFilterByQuotationName = (value) => {
    const filteredQuotations = mockQuotations.filter((quotation) => (
      quotation.quotation_name.toLowerCase().includes(value.toLowerCase())
    ));
    setAllQuotations(filteredQuotations);
  };

  useEffect(async () => {
    if (isLoading.categories) return;
    setIsLoading((prevState) => ({ ...prevState, categories: true }));
    const data = await Categories.getCategoriesByUser(userId);
    setCategories(data);
    setIsLoading((prevState) => ({ ...prevState, categories: false }));
  }, [newCategoryAdded.count]);

  useEffect(() => {
    if (categories?.length === 0) return;
    setIsLoading((prevState) => ({ ...prevState, quotations: true }));
    if (selectedCategory?.category_name) {
      Quotations.user.getFilteredByCategory(userId, selectedCategory.category_name)
        .then((response) => {
          setAllQuotations(response);
          setMockQuotations(response);
          setIsLoading((prevState) => ({ ...prevState, quotations: false }));
        })
        .catch((err) => console.log(err));
    } else {
      setAllQuotations([]);
      setIsLoading((prevState) => ({ ...prevState, quotations: false }));
    }
  }, [selectedCategory]);

  return (
    <>
      <div style={{ margin: '50px' }} className="container">
        <p className="header">TUS COTIZACIONES DE COSTOS</p>
        <div>
          <div className="banner-container">
            {selectedCategory.selectedOption === 'Nueva categoria' ? (
              <div
                role="none"
                className="add-new-category-div"
                onClick={() => setShowAddCategoryModal(true)}
              >
                <input
                  className="select add-new-category-input"
                  placeholder="Nombre de la categoria"
                  disabled={isLoading.categories}
                  value={newCategoryAdded.value}
                  onChange={(e) => {
                    setNewCategoryAdded((prevState) => ({
                      ...prevState,
                      value: e.target.value,
                      isValidCategoryName: !(/[+#%&?=]/).test(e.target.value),
                    }));
                  }}
                />
                {(showAddCategoryModal) && (
                  <div className="add-new-category-modal">
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {(!newCategoryAdded?.value)
                        && (
                        <div
                          style={{
                            width: '10px',
                            height: '10px',
                            backgroundColor: '#b1b1b1',
                            borderRadius: '50%',
                            marginRight: '10px',
                          }}
                        />
                        )}
                      {(newCategoryAdded?.value && newCategoryAdded.isValidCategoryName === true)
                        && (
                        <Check className="appear" sx={{ color: 'green', fontSize: '15px', marginRight: '5px' }} />
                        )}
                      {(newCategoryAdded?.value && newCategoryAdded.isValidCategoryName === false)
                        && (
                        <Clear className="appear" sx={{ color: 'red', fontSize: '15px', marginRight: '5px' }} />
                        )}
                      <p
                        className="none-styles"
                        style={{
                          borderRadius: '5px', margin: '0', fontSize: '12px', color: 'gray', width: '100%',
                        }}
                      >
                        Simbolos no permitidos: &quot; + # % & ? = &quot;
                      </p>
                    </div>
                    <p role="none" onClick={() => handleCreateCategory()}>Guardar Categoria</p>
                    <p role="none" onClick={() => setSelectedCategory({})}>Cancelar</p>
                  </div>
                )}
              </div>
            ) : (
              <SelectFilter
                array={categories}
                placeholderInput="Todas las categorias"
                placeholderFilter="Busca una categoria"
                listTitle="Categorias :"
                addNewElement="Nueva categoria"
                propertyShown="category_name"
                selectValue={selectedCategory}
                setSelectValue={setSelectedCategory}
                loading={isLoading.quotations || isLoading.categories}
                required
              />
            )}
            <div className="categories-wrapper">
              {categories?.length > 0 && categories.map((category) => (
                <div
                  role="none"
                  className="category-item"
                  onClick={() => {
                    if (isLoading.quotations) {
                      toaster.warning('Cargando, espere un momento', {
                        id: 'forbidden-action',
                        duration: 1.5,
                      });
                    } else {
                      setSelectedCategory(category);
                    }
                  }}
                  style={{ borderBottom: selectedCategory?.id === category?.id && '3px solid #4e4e4e' }}
                >
                  <p>{category?.category_name}</p>
                </div>
              ))}
            </div>
            {isLoading.categories && (
              <CircularProgress
                color="inherit"
                style={{
                  padding: '5px', margin: 'auto 10px', width: '40px', height: '40px',
                }}
              />
            )}
          </div>

          <div className="filters-container">
            <input placeholder="Filtrar por nombre de cotizacion" onChange={(e) => handleFilterByQuotationName(e.target.value)} />
            <button disabled type="button" className="simple-button" onClick={() => setShowFilterOptions(!showFilterOptions)}>Filtrar</button>
            <button
              type="button"
              className="simple-button"
              onClick={() => setShowAddAdditionalInfo((prevSate) => ({ ...prevSate, showModal: !prevSate.showModal }))}
            >
              <RemoveRedEye />
              Mostrar
            </button>
            <button disabled type="button" className="simple-button" onClick={() => setShowOrderOptions(!showOrderOptions)}>Ordenar</button>
          </div>
        </div>

        <div className="user-quotations-container">
          {isLoading.quotations && (<div style={{ textAlign: 'center', margin: '30px auto' }}><CircularProgress color="inherit" /></div>)}
          {(allQuotations?.length > 0 && !isLoading.quotations) && allQuotations.map((quotation) => (
            <div key={quotation?.id} className="user-quotations-wrapper">
              <Divider label="Datos de la Cotizacion" />
              {showAddAdditionalInfo?.id && (
              <div>
                <p>Id :</p>
                <p>{quotation?.id}</p>
              </div>
              )}
              {showAddAdditionalInfo.quotation_name && (
              <div>
                <p>Cotizacion :</p>
                <p>{quotation.quotation_name}</p>
              </div>
              )}
              {showAddAdditionalInfo.category && (
              <div>
                <p>Categoria :</p>
                <p>{quotation.category}</p>
              </div>
              )}
              {showAddAdditionalInfo.machine && (
              <div>
                <p>Maquina :</p>
                <p>{quotation.machine}</p>
              </div>
              )}
              {(showAddAdditionalInfo.materials && quotation.type_material?.length > 0) && (
              <div>
                <p>Materiales :</p>
                <p>{quotation.type_material.join()}</p>
              </div>
              )}
              <Divider label="Detalle de costos" />
              {showAddAdditionalInfo.cost_per_piece && (
              <div>
                <p>Costo por diseño :</p>
                <p>{quotation.cost_per_piece}</p>
              </div>
              )}
              {showAddAdditionalInfo.cost_electricity && (
              <div>
                <p>Costo de electricidad :</p>
                <p>{quotation.cost_electricity}</p>
              </div>
              )}
              {showAddAdditionalInfo.cost_operator && (
              <div>
                <p>Costo de operacion :</p>
                <p>{quotation.cost_operator}</p>
              </div>
              )}
              {showAddAdditionalInfo.cost_total_per_piece && (
              <div>
                <p>Costo total del diseño :</p>
                <p>{quotation.cost_total_per_piece}</p>
              </div>
              )}
              {showAddAdditionalInfo.price_per_design && (
              <div>
                <p>Precio de venta :</p>
                <p>{quotation.price_per_design}</p>
              </div>
              )}
              <Divider textColor="green" label="Retorno de inversion" />
              {showAddAdditionalInfo.utility && (
              <div>
                <p>Utilidad :</p>
                <p>{toInteger(quotation.price_per_design - quotation.cost_total_per_piece, 2)}</p>
              </div>
              )}
              {showAddAdditionalInfo.pieces_to_sell && (
              <div>
                <p>Piezas a vender:</p>
                <p>{quotation.pieces_to_sell}</p>
              </div>
              )}
              {showAddAdditionalInfo.show_pdf && (
              <iframe title={quotation?.id} src={quotation.pdf_url} scrolling="no" height="400px" width="100%" />
              )}
              <a style={{ textDecoration: 'none' }} href={quotation.pdf_url} download rel="noreferrer" target="_blank">
                <button style={{ margin: '20px auto 0 auto' }} className="simple-button" type="button">Abrir</button>
              </a>
            </div>
          ))}
        </div>
      </div>

      {showAddAdditionalInfo.showModal
      && (
      <Modal className="modal-see-additional-info">
        <button
          type="button"
          className="simple-button"
          style={{
            position: 'absolute', top: '10px', right: '10px', borderRadius: '5px',
          }}
          onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, showModal: false }))}
        >
          <Clear style={{ fontSize: '15px' }} />
        </button>
        <p>Ver Informacion Adicional:</p>
        <div role="none" onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, id: !showAddAdditionalInfo.id }))}>
          <input
            type="checkbox"
            checked={showAddAdditionalInfo.id}
          />
          <p>Id</p>
        </div>
        <div role="none" onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, quotation_name: !showAddAdditionalInfo.quotation_name }))}>
          <input
            type="checkbox"
            checked={showAddAdditionalInfo.quotation_name}
          />
          <p>Nombre de la cotizacion</p>
        </div>
        <div role="none" onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, category: !showAddAdditionalInfo.category }))}>
          <input
            type="checkbox"
            checked={showAddAdditionalInfo.category}
          />
          <p>Categoria</p>
        </div>
        <div role="none" onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, machine: !showAddAdditionalInfo.machine }))}>
          <input
            type="checkbox"
            checked={showAddAdditionalInfo.machine}
          />
          <p>Maquina</p>
        </div>
        <div role="none" onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, materials: !showAddAdditionalInfo.materials }))}>
          <input
            type="checkbox"
            checked={showAddAdditionalInfo.materials}
          />
          <p>Materiales</p>
        </div>
        <div role="none" onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, cost_per_piece: !showAddAdditionalInfo.cost_per_piece }))}>
          <input
            type="checkbox"
            checked={showAddAdditionalInfo.cost_per_piece}
          />
          <p>Costo por diseño</p>
        </div>
        <div role="none" onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, cost_electricity: !showAddAdditionalInfo.cost_electricity }))}>
          <input
            type="checkbox"
            checked={showAddAdditionalInfo.cost_electricity}
          />
          <p>Costo de electricidad</p>
        </div>
        <div role="none" onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, cost_operator: !showAddAdditionalInfo.cost_operator }))}>
          <input
            type="checkbox"
            checked={showAddAdditionalInfo.cost_operator}
          />
          <p>Costo de operacion</p>
        </div>
        <div role="none" onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, cost_total_per_piece: !showAddAdditionalInfo.cost_total_per_piece }))}>
          <input
            type="checkbox"
            checked={showAddAdditionalInfo.cost_total_per_piece}
          />
          <p>Costo total del diseño</p>
        </div>
        <div role="none" onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, price_per_design: !showAddAdditionalInfo.price_per_design }))}>
          <input
            type="checkbox"
            checked={showAddAdditionalInfo.price_per_design}
          />
          <p>Precio de venta</p>
        </div>
        <div role="none" onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, utility: !showAddAdditionalInfo.utility }))}>
          <input
            type="checkbox"
            checked={showAddAdditionalInfo.utility}
          />
          <p>Utilidad</p>
        </div>
        <div role="none" onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, pieces_to_sell: !showAddAdditionalInfo.pieces_to_sell }))}>
          <input
            type="checkbox"
            checked={showAddAdditionalInfo.pieces_to_sell}
          />
          <p>Piezas a vender</p>
        </div>
        <div role="none" onClick={() => setShowAddAdditionalInfo((prevState) => ({ ...prevState, show_pdf: !showAddAdditionalInfo.show_pdf }))}>
          <input
            type="checkbox"
            checked={showAddAdditionalInfo.show_pdf}
          />
          <p>previsualizar PDF</p>
        </div>
      </Modal>
      )}
      {showFilterOptions
      && (
      <Modal className="modal-see-additional-info">
        <p>Ver Informacion</p>
        <div>
          <input type="checkbox" />
          <p>Id</p>
        </div>
        <div>
          <input type="checkbox" />
          <p>Costo de operacion</p>
        </div>
        <div>
          <input type="checkbox" />
          <p>Costo de electricidad</p>
        </div>
        <div>
          <input type="checkbox" />
          <p>Piezas a vender</p>
        </div>
        <div>
          <input type="checkbox" />
          <p>previsualizar PDF</p>
        </div>
      </Modal>
      )}
      {showOrderOptions
      && (
      <Modal className="modal-see-additional-info">
        <p>Ver Informacion</p>
        <div>
          <input type="checkbox" />
          <p>Id</p>
        </div>
        <div>
          <input type="checkbox" />
          <p>previsualizar PDF</p>
        </div>
      </Modal>
      )}
    </>
  );
};

export default UserQuotations;
